import type { FaireProductEntity } from "../../entity_types/product";

export const p_jhcrb92fnq: FaireProductEntity = {
  token: "p_jhcrb92fnq",
  type: "product",
  name: "Chain Fringe 18K Gold Plated Stainless Steel Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ffb4a23a648bb91b03dd2d8bce0d6b98898987b73a1d8b0e5b56ccbe371f7181.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33c921c6426e5f30484e1b068a8dbd28c9018239f2b39aa4ad85fa97c5f4ac56.jpeg",
    "https://cdn.faire.com/fastly/b5a758cda11ffa8a999749ba1cac94ad004ef7e0cdeb5aa1e373ecb46eb70719.jpeg",
    "https://cdn.faire.com/fastly/94189cc562acfb8ea0bdddccff4f5962c1560b78d2997dc2862c44e7867a7242.jpeg",
    "https://cdn.faire.com/fastly/d52d015410b4b991d297b61f48ad9d163985b87da97156f524c79d4fb59fd4fd.jpeg",
    "https://cdn.faire.com/fastly/8ab2bf8e0c8127d5c79c9b400f9874237a34ee3f7687edf556b723e64700dded.jpeg",
  ],
  priceDollars: 15.36,
  description:
    "Type: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :22mm*35mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 30.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:53.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
